import React, { useContext, useEffect, useState } from 'react'
import Select from "react-select";
import { getImages } from '../Const'
import { LeadsContext } from '../Context/LeadsContext';
import { startOfToday, endOfToday, startOfTomorrow, endOfTomorrow, startOfWeek, endOfWeek, subWeeks, addWeeks, addDays, startOfYesterday, endOfYesterday } from "date-fns";

const date_range_option = [
    { value: "all", label: "All" },
    //{ value: "7_days", label: "Next 7 Days" },
    { value: "today", label: "Today" },
    //{ value: "tomorrow", label: "Tomorrow" },
    //{ value: "this_week", label: "This Week" },
    //{ value: "next_week", label: "Next Week" },
    //{ value: "last_week", label: "Last Week" },
    { value: "overdue", label: "Overdue" },
    { value: "yesterday", label: "Yesterday" },
];

const web_channel_option = [
    { value: "all", label: "All Locations" },
    { value: "EQR_Pompano", label: "EQR - Pompano" },
    { value: "EQR_Boynton", label: "EQR - Boynton" },
    { value: "KBB_Pompano", label: "KBB - Pompano" },
    { value: "KBB_Boynton", label: "KBB - Boynton" },
    { value: "Mall", label: "Mall" }
];

const instore_channel_option = [
    { value: "all", label: "All Locations" },
    { value: "EQR_Pompano", label: "EQR - Pompano" },
    { value: "EQR_Boynton", label: "EQR - Boynton" },
    { value: "KBB_Pompano", label: "KBB - Pompano" },
    { value: "KBB_Boynton", label: "KBB - Boynton" },
    { value: "Mall", label: "Mall" }
];
const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: "32px",
        height: "32px",
        fontSize: "14px",
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: "32px",
        padding: "0 6px",
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: "14px", // selected text font size
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: "14px",
        backgroundColor: state.isFocused
            ? "#b5f0ffff"
            : state.isSelected
                ? "#10758d"
                : "#fff",
        color: state.isSelected ? "#fff" : "#10758d",
        cursor: "pointer",
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
        fontSize: "14px",
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: "30px",
        padding: "5px 0px"
    }),
};
const TaskModal = ({ close, setTaskCount, inStore, location }) => {

    const { leadData, agentData, updateTask } = useContext(LeadsContext);
    const [taskStates, setTaskStates] = useState(leadData.tasks);
    // Filter
    const [selectedDateRange, setSelectedDateRange] = useState({ value: "all", label: "All" });
    const [selectedChannel, setSelectedChannel] = useState({ value: "all", label: "All Locations" });
    const [selectedUser, setSelectedUser] = useState({ value: "all", label: "All Users" });
    const [userOptions, setUserOptions] = useState([]);
    const [filteredTasks, setFilteredTasks] = useState(leadData.tasks);

    const handleRadioChange = (task_data, index, value) => {

        const newTaskStates = [...taskStates];
        newTaskStates[index]['completed'] = value;
        setTaskStates(newTaskStates);

        updateTask(task_data.lead_id, task_data.id, "", value);
    };

    const removeComplete = () => {
        const newTaskStates = [];

        taskStates.map((v, i) => {
            if (!v.completed) newTaskStates.push(v);
        });

        setTaskStates(newTaskStates);
    }

    var today = new Date();

    var tzoffset = today.getTimezoneOffset() * 60000;

    const taskDateChecks = [
        {   
            'check':'today',
            'start':startOfToday(today),
            'end':endOfToday(today)
        },
        {   
            'check':'tomorrow',
            'start':startOfTomorrow(today),
            'end':endOfTomorrow(today)
        },
        {   
            'check':'this_week',
            'start':startOfWeek(today, { weekStartsOn: 1 }),
            'end':endOfWeek(today, { weekStartsOn: 1 })
        },
        {   
            'check':'next_week',
            'start':startOfWeek(addWeeks(today,1), { weekStartsOn: 1 }),
            'end':endOfWeek(addWeeks(today,1), { weekStartsOn: 1 })
        },
        {   
            'check':'last_week',
            'start':startOfWeek(subWeeks(today,1), { weekStartsOn: 1 }),
            'end':endOfWeek(subWeeks(today,1), { weekStartsOn: 1 })
        },
        {   
            'check':'7_days',
            'start':startOfToday(today),
            'end':addDays(startOfToday(today),7)
        },
        {   
            'check':'yesterday',
            'start':startOfYesterday(today),
            'end':endOfYesterday(today)
        }
    ];

    useEffect(() => {
        var tasks = [];

        leadData.filter((lead) => !inStore || (inStore && lead.appraisal_stage == "Callback" && lead.location == location)).map((v, i) => {
            if (v.tasks && Array.isArray(v.tasks)) {

                //v.tasks.filter((this_task) => !this_task.completed).map((this_task,j) => {
                //});

                var this_task = v.tasks.find((task) => !task.completed);

                if(this_task) {

                    this_task.lead_id = v.id;
                    this_task.email = v.email;
                    this_task.vin = v.VIN;
                    this_task.full_name = v.full_name;
                    this_task.vehicle_name = v.vehicle_name;
                    this_task.agent_id = v.agent_id;
                    this_task.agent_name = v.agent_name;

                    this_task.date_obj = new Date(this_task.date_timestamp*1000 + tzoffset);

                    this_task.overdue = this_task.date_obj <= today;

                    this_task.dateCheck = {};

                    taskDateChecks.map((dates,j) => {
                        this_task.dateCheck[dates.check] = this_task.date_obj >= dates.start && this_task.date_obj <= dates.end;
                    });

                    if(v.lead_type == "EQR") this_task.channel = v.location == "POMPANO BEACH" ? "EQR_Pompano" : "EQR_Boynton";
                    else if(v.lead_type == "KBB") this_task.channel = v.location == "POMPANO BEACH" ? "KBB_Pompano" : "KBB_Boynton";
                    else if(v.lead_type == "KBB-K") this_task.channel = "MALL";
                    else this_task.channel = "OTHER";
                    
                    tasks.push(this_task);
                }
            }
        });

        setTaskCount(tasks.length);
        setTaskStates(tasks);
        setFilteredTasks(tasks.filter((task) => task.dateCheck.today))


    }, [leadData,location,inStore]);

    useEffect(() => {
        if (agentData && agentData.length > 0) {
            const uniqueUsers = [
                ...new Map(
                    agentData.filter((user) => user.lead_type == "Web").map((t) => [t.id, { value: t.id, label: t.full_name }])
                ).values(),
            ];

            // prepend "All Users"
            setUserOptions([{ value: "all", label: "All Users" }, ...uniqueUsers]);
        }
    }, [agentData, taskStates]);
    useEffect(() => {
        var filtered_leads = selectedUser && selectedUser.value === "all" ? taskStates : taskStates.filter((task) => task.agent_id === selectedUser.value);

        if(filtered_leads && selectedDateRange && selectedDateRange.value != "all" && selectedDateRange.value != "overdue") filtered_leads = filtered_leads.filter((task) => task.dateCheck[selectedDateRange.value]);

        if(filtered_leads && selectedChannel && selectedChannel.value != "all") filtered_leads = filtered_leads.filter((task) => task.channel == selectedChannel.value);

        setFilteredTasks(filtered_leads);
        
    }, [selectedDateRange,selectedUser,selectedChannel,taskStates]);
    return (
        <>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title text-uppercase w-100 text-center" id="staticBackdropLabel">
                        Tasks
                    </h1>
                    <button className="sm-box-close" type="button" onClick={close}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div className="modal-body white-bg p-4">
                    <div className='task-filter-form'>
                        <div className='row mb-4'>
                            <div className='col-md-3'>
                                <div className='cs-label mb-1'>Date Range</div>
                                <Select
                                    options={date_range_option}
                                    placeholder="All"
                                    styles={customStyles}
                                    components={{ IndicatorSeparator: () => null }}
                                    value={selectedDateRange}
                                    onChange={setSelectedDateRange}
                                />
                            </div>
                            {!inStore && <div className='col-md-3'>
                                <div className='cs-label mb-1'>User</div>
                                <Select
                                    options={userOptions}
                                    placeholder="All Users"
                                    styles={customStyles}
                                    components={{ IndicatorSeparator: () => null }}
                                    value={selectedUser}
                                    onChange={setSelectedUser}
                                />
                            </div>}
                            {!inStore && <div className='col-md-3'>
                                <div className='cs-label mb-1'>Location</div>
                                <Select
                                    options={inStore ? instore_channel_option : web_channel_option}
                                    placeholder="All Locations"
                                    styles={customStyles}
                                    components={{ IndicatorSeparator: () => null }}
                                    value={selectedChannel}
                                    onChange={setSelectedChannel}
                                />
                            </div>}
                        </div>
                    </div>
                    <div className='custom-table2 with-white-bg task-box'>
                        {selectedDateRange && (selectedDateRange.value == "overdue" || selectedDateRange.value == "all") && <div className='text-uppercase d-flex align-items-center'><span className='md-title text-red font-1-1em pe-2 d-inline-block'>Overdue Tasks</span> <span className='md-title text-red font-1-5em'>{filteredTasks && filteredTasks.filter((task) => task.overdue).length}</span></div>}
                        <table className='w-100'>
                            {selectedDateRange && (selectedDateRange.value == "overdue" || selectedDateRange.value == "all") && <thead>
                                <tr>
                                    <th className='text-center'>&nbsp;</th>
                                    <th>Task</th>
                                    <th className='text-center'>Date</th>
                                    <th className='text-center'>Name</th>
                                    <th className='text-center' style={{width:"35%"}}>Vehicle Details</th>
                                    <th className='text-center'></th>
                                </tr>
                            </thead>}
                            {selectedDateRange && (selectedDateRange.value == "overdue" || selectedDateRange.value == "all") && <tbody>
                                {filteredTasks && filteredTasks.sort((a,b) => b.date_obj - a.date_obj).filter((task) => task.overdue).map((v, i) => {
                                    const checked = v.completed != 0 && v.completed == 1;
                                    return (
                                        <tr key={i} >
                                            <td className="tm-col-1">
                                                <label className="custom-checkbox">
                                                    <input type="checkbox" id={`leadTask${i}`} checked={checked} value={checked ? "complete" : "incomplete"} onChange={(e) => { handleRadioChange(v, i, e.target.checked) }} />
                                                    <label htmlFor={`leadTask${i}`}></label>
                                                </label>
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center'>
                                                    <div className='mnw-25px text-center inv-title1 fw-500 dgray'>{i + 1}</div>
                                                    <div className='mnw-50px text-center'><span className='blue-envlope-icon'></span></div>
                                                    <div>
                                                        <div className='inv-title1 fw-500 dgray'>Day {v.day}</div>
                                                        <div className='inv-title2 gray'>{v.text}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='inv-title1 text-center dgray'>{v.date}</td>
                                            <td className='inv-title1 text-center dgray'>{v.full_name}</td>
                                            <td className='inv-title1 text-center dgray' style={{width:"35%"}}>{v.vehicle_name}</td>
                                            <td className='inv-title1 text-center dgray'><button className="blue-btn text-uppercase" type="button" onClick={() => {window.open((inStore ? "/store" : "/web") + "?lead_id=" + v.lead_id, "_blank");}}>Open</button></td>
                                        </tr>
                                    )
                                })}
                            </tbody>}
                            <tbody>
                                <tr>
                                    <td colSpan={6} className='col-ps-0' style={{ borderTop: 'none', paddingLeft: '0px' }}>
                                        <div className='text-uppercase d-flex align-items-center pt-5 pb-2'><span className='md-title font-1-1em pe-2 d-inline-block'>{selectedDateRange?.label ?? "Today's"} Tasks</span> <span className='md-title font-1-5em'>{filteredTasks?.length}</span></div>
                                    </td>
                                </tr>
                                {filteredTasks && filteredTasks.sort((a,b) => b.date_obj - a.date_obj).map((v, i) => {
                                    const checked = v.completed != 0 && v.completed == 1;
                                    return (
                                        <tr key={i} onClick={() => {window.open((inStore ? "/store" : "/web") + "?lead_id=" + v.lead_id, "_blank");}}>
                                            <td className="tm-col-1">
                                                <label className="custom-checkbox">
                                                    <input type="checkbox" id={`leadTask${i}`} checked={checked} value={checked ? "complete" : "incomplete"} onChange={(e) => { handleRadioChange(v, i, e.target.checked) }} />
                                                    <label htmlFor={`leadTask${i}`}></label>
                                                </label>
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center'>
                                                    <div className='mnw-25px text-center inv-title1 fw-500 dgray'>{i + 1}</div>
                                                    <div className='mnw-50px text-center'><span className='blue-envlope-icon'></span></div>
                                                    <div>
                                                        <div className='inv-title1 fw-500 dgray'>Day {v.day}</div>
                                                        <div className='inv-title2 gray'>{v.text}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='inv-title1 text-center dgray'>{v.date}</td>
                                            <td className='inv-title1 text-center dgray'>{v.full_name}</td>
                                            <td className='inv-title1 text-center dgray' style={{width:"35%"}}>{v.vehicle_name}</td>
                                            <td className='inv-title1 text-center dgray'><button className="blue-btn text-uppercase" type="button" onClick={() => {window.open((inStore ? "/store" : "/web") + "?lead_id=" + v.lead_id, "_blank");}}>Open</button></td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className='mt-4 d-flex align-items-center justify-content-between px-5'>
                        <div>
                            {/*<button className="text-nowrap blue-transparent-btn dark-transparent-btn text-uppercase py-2" type="button"><span className="blue-add-icon"></span> Add Task Reminder</button>*/}
                        </div>
                        <div>
                            <button className="blue-btn text-uppercase" type="button" onClick={(e) => { removeComplete(); }}>Remove Complete</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TaskModal